import { KatButton, KatModal } from '@amzn/katal-react';
import React from 'react';
import { ModalProps } from '../../types/bulkGslaTypes';

export const ConfirmationModal: React.FC<ModalProps> = ({
    isOpen,
    onClose,
    pendingChanges,
    uploadedData,
    onConfirm,
    isUploading
}) => (
    <KatModal
        visible={isOpen}
        title="Confirm GSLA Changes"
    >
        <div>
            <h4>The following GSLA changes will be applied:</h4>
            <table>
                <thead>
                    <tr>
                        <th>Warehouse</th>
                        <th>Production Capability</th>
                        <th>Handling Tier</th>
                        <th>Current GSLA</th>
                        <th>Recommended GSLA</th>
                        <th>Override Value</th>
                    </tr>
                </thead>
                <tbody>
                    {pendingChanges.map((change, index) => {
                        const originalRow = uploadedData.find(
                            row => row.warehouseId === change.warehouseId &&
                                row.productionCapability === change.productionCapability
                        );
                        return (
                            <tr key={index}>
                                <td>{change.warehouseId}</td>
                                <td>{change.productionCapability}</td>
                                <td>{change.warehouseHandlingTier}</td>
                                <td>{originalRow?.actualGSLA}</td>
                                <td>{originalRow?.recommendedGSLA}</td>
                                <td>{change.gslaInSeconds}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                <KatButton
                    variant="primary"
                    onClick={onConfirm}
                    disabled={isUploading}
                >
                    Confirm Changes
                </KatButton>
                <KatButton
                    variant="secondary"
                    onClick={onClose}
                >
                    Cancel
                </KatButton>
            </div>
        </div>
    </KatModal>
);
